import React from 'react';
import * as healthSectionstyles from './HealthSection.module.css';
import * as mediaLogoSectionStyles from './MediaLogoSection.module.css';
import { renderIconSection } from './iconSectionUtils';
import { IconSectionData } from '../../../types/KontentProps';

type Props = {
    iconData: IconSectionData;
    iconSectionBackgroundColor?: string | null;
    iconSectionTextColor?: string | null;
};

const IconSection: React.FC<Props> = ({
    iconData,
    iconSectionBackgroundColor,
    iconSectionTextColor,
}) => {
    return renderIconSection(
        iconData,
        healthSectionstyles,
        mediaLogoSectionStyles,
        iconSectionBackgroundColor || '',
        iconSectionTextColor || ''
    );
};

export default IconSection;
